import './text.scss';

function init() {
    console.log("text.js initialized");
}

export default init;

export function text(block) {
console.log("text block:", block); // reivew the below - move and tidyt up
}
// export function text(block) {
//     console.log("text block:", block);

//     // Find the ACF WYSIWYG editor field
//     var wysiwygField = acf.getField(block.dataset.key); // Use ACF API to get the field by key

//     if (wysiwygField) {
//         console.log("wysiwygField exists", wysiwygField);

//         // Get the DOM element associated with the ACF field
//         var wysiwygFieldEl = wysiwygField.$el[0];

//         console.log("wysiwygFieldEl", wysiwygFieldEl);



//         if (wysiwygFieldEl) {
//             // Find the textarea within the WYSIWYG field element
//             var textarea = wysiwygFieldEl.querySelector('textarea.wp-editor-area');


//             console.log("textarea", textarea);

//             if (textarea) {
//                 var tinyID = textarea.id;
//                 var tinyInstance = tinyMCE.get(tinyID);
//                 if (tinyInstance) {
//                     var description = "Some text!";
//                     tinyInstance.setContent(description);
//                     console.log("Content set in TinyMCE editor:", tinyID);
//                 } else {
//                     console.warn("TinyMCE editor instance not found for ID:", tinyID);
//                 }
//             } else {
//                 console.warn("Textarea (.wp-editor-area) not found in WYSIWYG field element.");
//             }
//         } else {
//             console.warn("WYSIWYG field element not found.");
//         }

//         // Additional logic to register a filter if needed
//         acf.addFilter('wysiwyg_tinymce_settings', function(settings, field) {
//             // Check if this is the correct field
//             console.log("Filter fired:", settings, field);
//             if (wysiwygField.get('key') === block.dataset.key) {

//                 console.log("initInlineReference about to run");
//                 initInlineReference(block);
//             }
//             // Add your logic here
//             return settings; // Make sure to return the modified settings
//         });
//     } else {
//         console.warn("WYSIWYG field not found for block with dataset key:", block.dataset.key);
//     }
// }

// export function initInlineReference(block) {
//     // Function to initialize the custom logic for inline references
//     console.log("initInlineReference:", block);

//     var links = block.querySelectorAll('a.reference__inline-item');
//     links.forEach(function(link) {
//         console.log("link:", link);

//         var text = link.textContent;
//         var numberMatch = text.match(/\d+|\(\d+\)/); // Extract plain numbers or numbers in parentheses

//         if (numberMatch) {
//             console.log("numberMatch:", numberMatch);

//             var number = numberMatch[0];
//             link.setAttribute('id', 'inline_ref_' + number);
//             link.setAttribute('href', '#ref_' + number);

//             link.style.color = 'red';

// console.log("link.style.color", link.style.color);
 
//         }
//     });
// }




// export function text(block) {
//     console.log("text block:", block);

//     // Find the ACF WYSIWYG editor field
//     var wysiwygField = acf.getField(block.dataset.key); // Use ACF API to get the field by key

//     if (wysiwygField) {
//         console.log("wysiwygField exists", wysiwygField);
//         console.log("acf", acf);

//         // Get the DOM element associated with the ACF field
//         var wysiwygFieldEl = wysiwygField.$el[0];

//         if (wysiwygFieldEl) {
//             // Find the textarea within the WYSIWYG field element
//             var textarea = wysiwygFieldEl.querySelector('textarea.wp-editor-area');

//             if (textarea) {
//                 var tinyID = textarea.id;
//                 var tinyInstance = tinyMCE.get(tinyID);
//                 if (tinyInstance) {
//                     var description = "Some text!";
//                     tinyInstance.setContent(description);
//                     console.log("Content set in TinyMCE editor:", tinyID);
//                 } else {
//                     console.warn("TinyMCE editor instance not found for ID:", tinyID);
//                 }
//             } else {
//                 console.warn("Textarea (.wp-editor-area) not found in WYSIWYG field element.");
//             }
//         } else {
//             console.warn("WYSIWYG field element not found.");
//         }

//         // Additional logic to register a filter if needed
//         acf.addFilter('wysiwyg_tinymce_settings', function(settings, field) {
//             // Check if this is the correct field
//             console.log("Filter fired:", settings, field);
//             if (field.get('key') === block.dataset.key) {
//                 initInlineReference(block);
//             }
//             // Add your logic here
//             return settings; // Make sure to return the modified settings
//         });
//     } else {
//         console.warn("WYSIWYG field not found for block with dataset key:", block.dataset.key);
//     }
// }

// export function initInlineReference(block) {
//     // Function to initialize the custom logic for inline references
//     console.log("initInlineReference:", block);

//     var links = block.querySelectorAll('a.reference__inline-item');
//     links.forEach(function(link) {
//         console.log("link:", link);

//         var text = link.textContent;
//         var numberMatch = text.match(/\d+|\(\d+\)/); // Extract plain numbers or numbers in parentheses

//         if (numberMatch) {
//             console.log("numberMatch:", numberMatch);

//             var number = numberMatch[0];
//             link.setAttribute('id', 'inline_ref_' + number);
//             link.setAttribute('href', '#ref_' + number);

//             link.style.color = 'red';
//         }
//     });
// }





// export function text(block) {
//     console.log("text block:", block);



// //     var description = "Some text!";
// // var f = acf.getField("field_5d5231b7e8738"); // this f
// // var tinyID = f.$el.find("textarea").attr("id");
// // var tinyInstance = tinyMCE.editors[tinyID];
// // tinyInstance.setContent(description);




//     // Find the ACF WYSIWYG editor field
//     var wysiwygField = acf.getField(block.dataset.key); // Use ACF API to get the field by key

//     console.log("wysiwygField", wysiwygField);

//     var description = "Some text!";

//     var tinyID = wysiwygField.querySelector("textarea").attr("id");
// var tinyInstance = tinyMCE.editors[tinyID];
// tinyInstance.setContent(description);


// console.log("tinyID", tinyID);

//     // if (wysiwygField) {
//     //     console.log("wysiwygField exists", wysiwygField);
//     //     console.log("acf", acf);
    
//     //     // Register a filter to run when the ACF field is updated
//     //     acf.addFilter('wysiwyg_tinymce_settings', function(settings, field) {
//     //         // Check if this is the correct field
//     //         console.log("Filter fired:", settings, field);

//     //         initInlineReference(block)
//     //         // Add your logic here
//     //         return settings; // Make sure to return the modified settings
//     //     });
//     // }

// }


// analyse where we we are with this - 
/*

the sissues surrounding the block and the text area are on the basisi of not updating on change
// the script runs on render block.

*/

export function _olkd_v2_initInlineReference(block) {
    // Function to initialize the custom logic for inline references

    console.log("initInlineReference:", block);

    // Find the textarea within the block
    var textarea = block.querySelector('textarea.wp-editor-area');

    if (textarea) {
        console.log('Found textarea:', textarea);

        var links = block.querySelectorAll('a.reference__inline-item');
        links.forEach(function(link) {
            var text = link.textContent;
            var numberMatch = text.match(/\d+|\(\d+\)/); // Extract plain numbers or numbers in parentheses

            if (numberMatch) {
                var number = numberMatch[0];
                link.setAttribute('id', 'inline_ref_' + number);
                link.setAttribute('href', '#ref_' + number);
                link.style.color = 'red';
            }
        });

        // Optionally trigger additional actions based on the textarea
    } else {
        console.warn('Textarea (.wp-editor-area) not found in block:', block);
    }
}




export function _old_initInlineReference(block) {
     // Function to initialize the custom logic for inline references
 
        console.log("initInlineReference:", block);



        var links = block.querySelectorAll('a.reference__inline-item');
        links.forEach(function(link) {

// links for eacdh block
console.log("link:", link);

            var text = link.textContent;
            // var numberMatch = text.match(/\d+/); // Extract the first number in the text
            var numberMatch = text.match(/\d+|\(\d+\)/); // Extract plain numbers or numbers in parentheses

            if (numberMatch) {
    console.log("numberMatch:", numberMatch);

                var number = numberMatch[0];
                link.setAttribute('id', 'inline_ref_' + number);
                link.setAttribute('href', '#ref_' + number);


                link.style.color = 'red';
            }
        });
    }
       

